import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';

i18next.addResourceBundle('en', 'mappingPage', en);

const MappingConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/mapping',
			exact: true,
			component: React.lazy(() => import('./Mapping'))
		}
	]
};

export default MappingConfig;
